import React, { FC, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { PictureProps } from '../../atoms/Picture';
import FormikField from '../../form/FormikField';
import FormFieldInputNumber, { FormFieldInputNumberProps } from '../../form/fields/FormFieldInputNumber';
import * as SC from './styled';
export type Values = {
  weight: string;
  size: string;
};
export type BMIPushProps = {
  className?: string;
  imageProps: PictureProps;
  title?: string;
  bmi?: string;
  text?: string;
  sizeInputProps?: FormFieldInputNumberProps;
  weightInputProps?: FormFieldInputNumberProps;
  submitLabel?: string;
  resultTitle?: string;
  resultValues: {
    thin: string;
    normal: string;
    overweight: string;
    obese: string;
    obese_severely: string;
    obese_morbidly: string;
  };
  validation: {
    required: string;
  };
  restartLabel?: string;
};
const BMIPush: FC<BMIPushProps> = ({
  className,
  imageProps,
  title,
  bmi,
  text,
  sizeInputProps,
  weightInputProps,
  submitLabel,
  resultTitle,
  resultValues,
  restartLabel,
  validation
}) => {
  const [value, setValue] = useState<number>(0);
  const [initialValues, setInitialValues] = useState<Values>({
    weight: '',
    size: ''
  });
  const handleSubmit = (values: Values) => {
    const weight = parseFloat(values.weight);
    const size = parseFloat(values.size);
    setInitialValues(values);
    setValue(Math.round(weight / (size / 100 * (size / 100)) * 10) / 10);
  };
  const valueText = useMemo(() => {
    if (value < 18.5) {
      return resultValues.thin;
    } else if (value >= 18.5 && value < 25) {
      return resultValues.normal;
    } else if (value >= 25 && value < 30) {
      return resultValues.overweight;
    } else if (value >= 30 && value < 35) {
      return resultValues.obese;
    } else if (value >= 35 && value < 40) {
      return resultValues.obese_severely;
    } else if (value >= 40) {
      return resultValues.obese_morbidly;
    }
  }, [resultValues, value]);
  return <SC.Main className={className}>
      <SC.BackgroundImage {...imageProps} />
      <SC.Content>
        {value ? <>
            <SC.Title>{resultTitle}</SC.Title>
            <SC.Value>{value}</SC.Value>
            <SC.Text>{valueText}</SC.Text>
            <SC.Restart label={restartLabel} onClick={() => setValue(0)} />
          </> : <>
            <SC.Title>{title}</SC.Title>
            <SC.BMI>{bmi}</SC.BMI>
            <SC.Text>{text}</SC.Text>
            <SC.Form initialValues={initialValues} onSubmit={handleSubmit} validationSchema={Yup.object().shape({
          weight: Yup.string().required(validation.required),
          size: Yup.string().required(validation.required)
        })}>
              <FormikField name={'size'} Component={FormFieldInputNumber} {...sizeInputProps} />
              <FormikField name={'weight'} Component={FormFieldInputNumber} {...weightInputProps} />
              <SC.Submit label={submitLabel} />
            </SC.Form>
          </>}
      </SC.Content>
    </SC.Main>;
};
export default BMIPush;